import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function OffersHeroBanner() {
  const [timeLeft, setTimeLeft] = useState({
    days: 2,
    hours: 15,
    minutes: 30,
    seconds: 45
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          days,
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) {
          seconds--;
        } else {
          seconds = 59;
          if (minutes > 0) {
            minutes--;
          } else {
            minutes = 59;
            if (hours > 0) {
              hours--;
            } else {
              hours = 23;
              if (days > 0) {
                days--;
              }
            }
          }
        }
        return {
          days,
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const [currentSlide, setCurrentSlide] = useState(0);
  const slides = [{
    title: 'MEGA SALE EVENT',
    subtitle: 'Up to 70% OFF on Selected Items',
    tag: 'LIMITED TIME OFFER',
    colors: 'from-purple-600 to-pink-600'
  }, {
    title: 'BUY 1 GET 1 FREE',
    subtitle: 'On All Vitamins & Supplements',
    tag: 'WEEKEND SPECIAL',
    colors: 'from-blue-600 to-cyan-500'
  }, {
    title: 'BEAUTY BONANZA',
    subtitle: 'Extra 20% OFF Skincare',
    tag: 'NEW ARRIVALS',
    colors: 'from-rose-500 to-orange-400'
  }];
  useEffect(() => {
    const slideTimer = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(slideTimer);
  }, [slides.length]);
  return <div id="hero-banner" className="container mx-auto px-4" data-id="element-4784" data-mp="3hklnl5v91fse">
      <div className="hidden md:block bg-gradient-to-r from-purple-600 to-pink-600 rounded-lg overflow-hidden relative" data-id="element-4785" data-mp="1jrpsx9800yhz">
        <div className="w-full" style={{
        paddingTop: '25.71%'
      }} data-id="element-4786" data-mp="1frns12a3893r"></div>
        <div className="absolute inset-0 flex items-center justify-between p-6 md:p-12" data-id="element-4787" data-mp="3981t7h7d0dsi">
          <div className="flex-1" data-id="element-4788" data-mp="3e2o7pt8qmmgt">
            <span className="text-xs md:text-sm font-bold bg-white text-purple-600 px-3 py-1 rounded-full mb-3 inline-block" data-id="element-4789" data-mp="309q63p5pby4t">
              LIMITED TIME OFFER
            </span>
            <h2 className="text-2xl md:text-4xl font-bold text-white mb-2" data-id="element-4790" data-mp="3s0crexr2jnka">
              MEGA SALE EVENT
            </h2>
            <p className="text-base md:text-xl text-white text-opacity-90" data-id="element-4791" data-mp="ul220l48eyj">
              Up to 70% OFF on Selected Items
            </p>
          </div>
          <div className="flex flex-col items-center bg-white bg-opacity-20 backdrop-blur-sm rounded-xl p-6 min-w-[280px]" data-id="element-4792" data-mp="3izehxzxv2nub">
            <div className="flex items-center gap-2 mb-4" data-id="element-4793" data-mp="27kixfxcj9s5u">
              <ClockIcon className="w-5 h-5 text-white" data-id="element-4794" data-mp="27iy2w7q7y97z" />
              <span className="text-white font-semibold text-sm" data-id="element-4795" data-mp="2ck5ao6sd38en">
                OFFER ENDS IN
              </span>
            </div>
            <div className="grid grid-cols-4 gap-3" data-id="element-4796" data-mp="241afcpc85z59">
              <div className="flex flex-col items-center" data-id="element-4797" data-mp="2019x0tm093sx">
                <div className="bg-white rounded-lg p-3 min-w-[60px]" data-id="element-4798" data-mp="200qgnhc06nh0">
                  <span className="text-2xl font-bold text-purple-600" data-id="element-4799" data-mp="2dzq10cshgg7d">
                    {String(timeLeft.days).padStart(2, '0')}
                  </span>
                </div>
                <span className="text-xs text-white mt-2 font-medium" data-id="element-4800" data-mp="1lbkfhntlun6h">
                  DAYS
                </span>
              </div>
              <div className="flex flex-col items-center" data-id="element-4801" data-mp="1gelrzo4g5eh9">
                <div className="bg-white rounded-lg p-3 min-w-[60px]" data-id="element-4802" data-mp="1v2f7z9xg2j0d">
                  <span className="text-2xl font-bold text-purple-600" data-id="element-4803" data-mp="1v3q6au84eyk3">
                    {String(timeLeft.hours).padStart(2, '0')}
                  </span>
                </div>
                <span className="text-xs text-white mt-2 font-medium" data-id="element-4804" data-mp="12jjbk71z46q7">
                  HOURS
                </span>
              </div>
              <div className="flex flex-col items-center" data-id="element-4805" data-mp="ve8c8cvmimh">
                <div className="bg-white rounded-lg p-3 min-w-[60px]" data-id="element-4806" data-mp="wz2vxz6y1kc">
                  <span className="text-2xl font-bold text-purple-600" data-id="element-4807" data-mp="5v0nwog6gayg">
                    {String(timeLeft.minutes).padStart(2, '0')}
                  </span>
                </div>
                <span className="text-xs text-white mt-2 font-medium" data-id="element-4808" data-mp="emstolu9avwp">
                  MINS
                </span>
              </div>
              <div className="flex flex-col items-center" data-id="element-4809" data-mp="jldx0u4t1vpd">
                <div className="bg-white rounded-lg p-3 min-w-[60px]" data-id="element-4810" data-mp="ojxkx02ylhkd">
                  <span className="text-2xl font-bold text-purple-600" data-id="element-4811" data-mp="tjtm6rk9uuw8">
                    {String(timeLeft.seconds).padStart(2, '0')}
                  </span>
                </div>
                <span className="text-xs text-white mt-2 font-medium" data-id="element-4812" data-mp="xjarnkzp7s1e">
                  SECS
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="md:hidden relative" data-id="element-4813" data-mp="2zeuoj6h5qhzt">
        <div className="relative aspect-[3/1] overflow-hidden rounded-t-xl" data-id="element-4814" data-mp="2rtsjsu3hnli2">
          <AnimatePresence mode="wait" data-id="element-4815" data-mp="2n2iuxvprkm78">
            <motion.div key={currentSlide} initial={{
            opacity: 0,
            x: 50
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: -50
          }} transition={{
            duration: 0.3
          }} className={`absolute inset-0 bg-gradient-to-r ${slides[currentSlide].colors}`} data-id="element-4816" data-mp="2n1hf7dxszbj6">
              <div className="absolute inset-0 flex flex-col justify-center px-6 py-8" data-id="element-4817" data-mp="31pvj7s6yh61b">
                <span className="text-xs font-bold bg-white text-gray-900 px-3 py-1 rounded-full mb-3 inline-block w-max shadow-sm" data-id="element-4818" data-mp="2wrk9dhgnuvj3">
                  {slides[currentSlide].tag}
                </span>
                <h2 className="text-3xl font-bold text-white mb-2 leading-tight" data-id="element-4819" data-mp="1lcdnc010kywj">
                  {slides[currentSlide].title}
                </h2>
                <p className="text-lg text-white text-opacity-95 font-medium" data-id="element-4820" data-mp="1rtfbfsobpd1m">
                  {slides[currentSlide].subtitle}
                </p>
              </div>
            </motion.div>
          </AnimatePresence>

          {/* Carousel Indicators */}
          <div className="absolute bottom-3 left-0 right-0 flex justify-center gap-1.5 z-10" data-id="element-4821" data-mp="1htog5orxuu0h">
            {slides.map((_, idx) => <button key={idx} onClick={() => setCurrentSlide(idx)} className={`h-1.5 rounded-full transition-all ${currentSlide === idx ? 'w-4 bg-white' : 'w-1.5 bg-white/50'}`} data-id="element-4822" data-mp="18ukuqe5au2it" data-mpi={idx} />)}
          </div>
        </div>
        <div className="bg-white rounded-b-xl shadow-lg border-t-2 border-gray-100 px-4 py-4 relative z-20 -mt-2" data-id="element-4823" data-mp="z2f355iyln45">
          <div className="flex items-center justify-center gap-2 mb-3" data-id="element-4824" data-mp="q43cj3i3epbp">
            <ClockIcon className="w-5 h-5 text-red-500 animate-pulse" data-id="element-4825" data-mp="q662jnj8wigf" />
            <span className="text-sm font-bold text-gray-900 uppercase" data-id="element-4826" data-mp="6j2xqbes19fp">
              Offer Ends In
            </span>
          </div>
          <div className="grid grid-cols-4 gap-2" data-id="element-4827" data-mp="1ljib86ceqm6">
            <div className="flex flex-col items-center" data-id="element-4828" data-mp="fk10kqdhbawp">
              <div className="bg-gray-100 rounded-lg p-3 w-full border border-gray-200" data-id="element-4829" data-mp="bhe58fhln7ur">
                <span className="text-2xl font-bold text-gray-900 block text-center" data-id="element-4830" data-mp="bjqvrh1faqjf">
                  {String(timeLeft.days).padStart(2, '0')}
                </span>
              </div>
              <span className="text-[10px] text-gray-500 mt-1.5 font-bold uppercase tracking-wider" data-id="element-4831" data-mp="kfyjn4g4mvd6">
                Days
              </span>
            </div>
            <div className="flex flex-col items-center" data-id="element-4832" data-mp="u8x72izw0fv7">
              <div className="bg-gray-100 rounded-lg p-3 w-full border border-gray-200" data-id="element-4833" data-mp="187n5c1yg0ll5">
                <span className="text-2xl font-bold text-gray-900 block text-center" data-id="element-4834" data-mp="185aoxt8c2ja7">
                  {String(timeLeft.hours).padStart(2, '0')}
                </span>
              </div>
              <span className="text-[10px] text-gray-500 mt-1.5 font-bold uppercase tracking-wider" data-id="element-4835" data-mp="2an40fzgqoybm">
                Hours
              </span>
            </div>
            <div className="flex flex-col items-center" data-id="element-4836" data-mp="2jmr46rwxyg7u">
              <div className="bg-gray-100 rounded-lg p-3 w-full border border-gray-200" data-id="element-4837" data-mp="2oksjr2v5rxek">
                <span className="text-2xl font-bold text-gray-900 block text-center" data-id="element-4838" data-mp="2oieq8yg4mt94">
                  {String(timeLeft.minutes).padStart(2, '0')}
                </span>
              </div>
              <span className="text-[10px] text-gray-500 mt-1.5 font-bold uppercase tracking-wider" data-id="element-4839" data-mp="1vu0tsn4os4zo">
                Mins
              </span>
            </div>
            <div className="flex flex-col items-center" data-id="element-4840" data-mp="25mydgwlezzzv">
              <div className="bg-gray-100 rounded-lg p-3 w-full border border-gray-200" data-id="element-4841" data-mp="186iv07n086n7">
                <span className="text-2xl font-bold text-red-600 block text-center" data-id="element-4842" data-mp="184ojtl1jbswb">
                  {String(timeLeft.seconds).padStart(2, '0')}
                </span>
              </div>
              <span className="text-[10px] text-gray-500 mt-1.5 font-bold uppercase tracking-wider" data-id="element-4843" data-mp="15k0bftg3uhwr">
                Secs
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>;
}